import React from 'react'
import Picker from './picker'

const Calendar = () => {
  return (
    <div
      style={{
        position: 'fixed'
      }}>
      <Picker
        path={'node.panel.fromDate'}
        oppositePath={'node.panel.toDate'}
        before
      />
      <div style={{ width: 7, display: 'inline-block' }} />
      <Picker path={'node.panel.toDate'} oppositePath={'node.panel.fromDate'} />
    </div>
  )
}

export default Calendar



// WEBPACK FOOTER //
// ./src/components/Node/Calendar/calendar.js